// news-ticker.js
import { mediaQueryLg } from './media-query';

// news-ticker の動作
export function newsTicker() {
  let tickerBox = null, tickerAll = null, tickerCloneAll = null, tickerWidth = null, count = null, move = 0, margin = 0;

  // Initialize
  tickerInit();
  // Start moving after initialization
  setTimeout(() => {
    setInterval(tickerMove, 16); // Increased frequency for smoother animation
  }, 50);

  function tickerInit() {
    // Content duplication
    tickerBox = document.querySelector('#js-news-ticker div.news-ticker__inner');
    if (!tickerBox) {
      console.error('Ticker box not found');
      return;
    }
    tickerWidth = tickerBox.offsetWidth;
    margin = window.innerWidth * 0.05;
    count = Math.floor((window.innerWidth * 2) / (tickerWidth + margin));

    const container = document.getElementById('js-news-ticker');
    for (let i = 0; i < count; i++) {
      let clone = tickerBox.cloneNode(true);
      clone.classList.add('news-ticker__inner-clone');
      container.appendChild(clone);
    }

    // Ticker duplication
    let originalTicker = document.getElementById('js-news-ticker');
    let cloneTicker = originalTicker.cloneNode(true);
    cloneTicker.id = 'js-news-ticker_clone';
    originalTicker.parentNode.insertBefore(cloneTicker, originalTicker.nextSibling);
    cloneTicker.style.display = 'none';

    tickerAll = document.querySelectorAll('#js-news-ticker div.news-ticker__inner, #js-news-ticker div.news-ticker__inner-clone');
    tickerCloneAll = document.querySelectorAll('#js-news-ticker_clone div.news-ticker__inner, #js-news-ticker_clone div.news-ticker__inner-clone');

    // Layout
    for (let i = 0; i < tickerAll.length; i++) {
      let left = i * (tickerWidth + margin);
      tickerAll[i].style.left = `${left}px`;
      tickerCloneAll[i].style.left = `${left}px`;
    }

    // console.log(`Initialized with ${tickerAll.length} tickers, width: ${tickerWidth}, margin: ${margin}`);
  }

  function tickerMove() {
    move = tickerWidth / 500; // Adjusted for smoother movement
    for (let i = 0; i < tickerAll.length; i++) {
      let pos = parseFloat(tickerAll[i].style.left);
      if (isNaN(pos)) pos = 0;

      if (pos + tickerWidth < 0) {
        pos = (tickerAll.length - 1) * (tickerWidth + margin);
      } else {
        pos -= move;
      }

      tickerAll[i].style.left = `${pos}px`;
      tickerCloneAll[i].style.left = `${pos}px`;
    }
  }
}

// news-ticker の width を設定

export function setWidth_ticker() {
  const ticker = document.getElementById('js-news-ticker');
  const recruitLink = document.querySelector('#nav__item_recruit');

  function updateWidth() {
    if (ticker && recruitLink) {
      if (mediaQueryLg.matches) {
        const recruitWidth = recruitLink.offsetWidth;
        const windowWidth = window.innerWidth;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const tickerWidth = windowWidth - recruitWidth - scrollbarWidth;
        ticker.style.width = `${tickerWidth}px`;
      } else {
        ticker.style.width = '100%';
      }
    }
  }

  // Initial call to set the width
  updateWidth();

  // Add event listener for window resize
  window.addEventListener('resize', updateWidth);
}